module.exports = __webpack_public_path__ + "static/media/15.f0e59ba0.webp";